import { API_TEMPLATE, Operator } from '../libs/constant'
import { post, get } from '../libs/query'

const api = {
  list ({ criteria, page, size, isViewList = true }) {
    const path = API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_FILTER
    return post(`${path}?isViewList=${isViewList}`, { criteria, page, size })
  },
  listBySession (sessionId) {
    return api.list({
      criteria: [{ field: 'sessionId', operator: Operator.EQUAL, value: sessionId }],
      page: 0,
      size: 100,
      isViewList: false
    })
  },
  detail (id) {
    return get(`${API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_DETAIL}?id=${id}`)
  },
  assign ({ userId, id }) {
    const path = API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_ASSIGN
    return post(`${path}?userId=${userId}&taskId=${id}`)
  },
  assignSelf (id) {
    return post(`${API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_ASSIGN_SELF}?taskId=${id}`)
  },
  assignMultiple ({ userId, ids }) {
    return post(API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_ASSIGN_MULTIPLE, { userId, taskIds: ids })
  },
  assignBatch (payload) {
    return post(API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_ASSIGN_BATCH, payload)
  },
  cancel (id) {
    return post(`${API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_CANCEL}?id=${id}`)
  },
  create (payload) {
    return post(API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_CREATE_MANUALLY, payload)
  },
  update (payload) {
    return post(API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_UPDATE, payload)
  },
  report (sheetId, sheetName, payload) {
    return post(
      `${API_TEMPLATE.TICKET_SUPPOR_TECHNICAL_REPORT}?sheetId=${sheetId}&sheetName=${sheetName}`,
      payload
    )
  },
  collaboratorOptions ({ classType, timeSlot }) {
    return get(`${API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_COLLABORATOR_OPTIONS}?classType=${classType}&timeSlot=${timeSlot}`)
  },
  collaboratorOptionsForTicket (taskId) {
    return get(`${API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_COLLABORATOR_OPTIONS_FOR_TICKET}?taskId=${taskId}`)
  },
  getCollaboratorList ({ classType, timeSlot }) {
    return get(`${API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_COLLABORATOR}?classType=${classType}&timeSlot=${timeSlot}`)
  },
  deleteCollaborator (ids) {
    return post(API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_COLLABORATOR_DELETE, ids)
  },
  divideTicket (payload) {
    return post(API_TEMPLATE.TICKET_SUPPORT_TECHNICAL_COLLABORATOR, payload)
  }
}

export default api
